import { Card, Col, Row } from 'antd';
import React from 'react'
import BankAccounts from '../BankAccounts';
import CreditCards from '../CreditCards';

function FinancialInformation() {
  return (
    <Card title="Financial Information" className='financial-information'>
      <Row gutter={[0, 8]}>
        <Col span={24}>
            <BankAccounts />
        </Col>
        <Col span={24}>
            <CreditCards />
        </Col>
      </Row>
    </Card>
  )
}

export default FinancialInformation;
